import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierMinusOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M6 10.1v1.8h10v-1.8z" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 1C3.5 1 1 6 1 11s2.5 10 10 10c2.96 0 5.142-.779 6.698-2.03l4.026 4.026 1.272-1.272-4.034-4.034C20.415 15.837 21 13.418 21 11c0-5-2.5-10-10-10M4.57 5.277C3.362 6.727 2.8 8.767 2.8 11s.562 4.272 1.77 5.723C5.73 18.115 7.683 19.2 11 19.2s5.27-1.085 6.43-2.477c1.208-1.45 1.77-3.49 1.77-5.723s-.562-4.272-1.77-5.723C16.27 3.885 14.317 2.8 11 2.8S5.73 3.885 4.57 5.277"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
MagnifierMinusOutlinedSize24Glyph.displayName = 'MagnifierMinusOutlinedSize24Glyph';
